export const assets = {
  logo: './assets/images/real-estate.png',
  adminIcon: 'assets/images/profile (1).png',
  placeHolderLogo: 'assets/images/placeholder.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  ReveiwIcon: 'assets/images/rating.svg',
  cameraIcon: 'assets/images/camera_icon.svg',
  CmsIcon: 'assets/images/cms.svg',
  download: 'assets/images/download-pdf.png',
  LogoutIcon: 'assets/images/logout.svg',
  plus: 'assets/images/plus.png',
  CategoryIcon: 'assets/images/category.svg',
  NotificationIcon: 'assets/images/notification.svg',
  ReportIcon: 'assets/images/reports.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  ProductIcon: 'assets/images/product_icon.svg',
  OrderIcon: 'assets/images/order_icon.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  CouponsIcon: 'assets/images/coupons_icon.svg',
  PropertyIcon: 'assets/images/building.png',
  ChatIcon: 'assets/images/chat.png',
  HouseIcon: 'assets/images/house.png',
  AdvertisementIcon: 'assets/images/advertising.png',
  PortfolioIcon: 'assets/images/briefcase.png',
  SubadminIcon: 'assets/images/sub-admin.png',
  LoyaltyIcon: 'assets/images/fidelity.png',
  paymentIcon: 'assets/images/money-transfer.png',
  pdf: 'assets/images/pdf.png',
};
